import { AppVersionBanner } from "./AppVersionBanner";
import { useAppVersionMismatch } from "./useAppVersionMismatch";

export function VersionWatch() {
  const mismatch = useAppVersionMismatch();
  if (!mismatch) {
    return null;
  }
  return <AppVersionBanner />;
}
